import React, { useContext, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { imgBaseUrl } from "../../Const";
import NoPropertyImg from "../../images/no_property.png";
import EmailAgentModal from "../modal/EmailAgentModal";
import ContectModal from "../modal/ContectModal";
import { formatNumber, formatShortNumber } from "../CommonFun";
import ImagesModal from "../modal/ImagesModal";
import Login from "../../pages/common/Login";
import dummyPerson from "../../images/dummy_person.png";
import { RiMedal2Fill } from "react-icons/ri";
import ImageGallery from "../ImageGallery";
import { PropertyContext } from "../../context/PropertyContext";
import { ImageLoader } from "../loader/LoaderCommon";
import { REBathtub, REBedOutline, RECamera, RELocation, REMdHeart, RESQFOOT, REToilet } from "../icons/IconSvg";
import UseCachedImage from "../CustomizedHook/UseCachedImage";
// import UseCachedImage from "../CustomizedHook/UseCachedImage.js";

export default function PropertySection({ ltsProperties, name, agentData, agentId }) {
    const { setPropertyUId } = useContext(PropertyContext);
    const [favList, setFavList] = useState([]);
    const [imgModalShow, setImgModalShow] = useState(false);
    const [propertyImgsmdl, setPropertyImgsmdl] = useState([]);
    const [imgID, setImgID] = useState(0);
    const [emailModalShow, setEmailModalShow] = useState({ show: false, data: "" });
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: "" });
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loginModal, setLoginModal] = useState(false);
    const [isAuth, setISAuth] = useState(null);
    const [isImgFlag, setIsImagFlag] = useState(false);
    const handleLoginOpen = () => setLoginModal(true);
    const handleLoginClose = () => setLoginModal(false);

    useEffect(() => {
        const storedFavs = JSON.parse(localStorage.getItem("favProperty")) || [];
        setFavList(storedFavs);
    }, []);
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "100px" },
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    // useEffect(() => {
    //     ltsProperties?.forEach((property) => {
    //         property?.images?.forEach((imgObj) => {
    //             if (imgObj?.path) {
    //                 const img = new Image();
    //                 img.src = imgBaseUrl + imgObj.path;
    //             }
    //         });
    //     });
    // }, [ltsProperties]);
    const handleFavProperty = (data) => {
        const favProperty = JSON.parse(localStorage.getItem("favProperty")) || [];
        const updatedFavs = favProperty.some((p) => p.id === data.id) ? favProperty : [...favProperty, data];
        setFavList(updatedFavs);
        localStorage.setItem("favProperty", JSON.stringify(updatedFavs));
    };

    const handleDisFavProperty = (data) => {
        const newLikedCoins = favList.filter((coin) => coin.id !== data.id);
        setFavList(newLikedCoins);
        localStorage.setItem("favProperty", JSON.stringify(newLikedCoins));
    };

    const handleClose = () => {
        setImgID(0);
        setImgModalShow(false);
        setPropertyImgsmdl([]);
    };

    const handleModalHide = () => setEmailModalShow({ show: false, data: "" });
    const handlePhoneModalHide = () => setPhoneModalShow({ ...phoneModalShow, show: false });

    const handlePrevClick = () => {
        setIsImagFlag(false);
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
    };
    const handleNextClick = (item) => {
        setIsImagFlag(false);
        setCurrentIndex((prevIndex) => (prevIndex < item?.length - 1 ? prevIndex + 1 : prevIndex));
    };
    return (
        <>
            <div className="row slider-section info-block">
                {ltsProperties.map((item, i) => (
                    <div className={`info-block-inner ${name == "agent" ? "info-block-agent" : ""} position-relative`} key={i}>
                        {/* <Link to={`/property/details/${item.slug}`} title={item.title} onClick={() => setPropertyUId(item.uId)}> */}
                        {/* <article> */}
                        <Link to={`${window.location.origin}/property/details/${item.slug}_${item.uId}`} index={i} title={item.title} className="link_anchor"></Link>
                            <div className="slider-card">
                                <div className="slide-card-img image-swiper-wrapper slider_inner">
                                    {item?.images.length > 0 ? (
                                        <Swiper lazy={{ loadPrevNext: true }} modules={[Navigation, Pagination]} slidesPerView={1} spaceBetween={20} navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }} pagination={{ clickable: true, dynamicBullets: true }} loop={false}>
                                            {item?.images.length > 0 &&
                                                item?.images
                                                    .filter((img) => !img.needHide)
                                                    .sort((a, b) => {
                                                        if (a.isCover) return -1;
                                                        if (b.isCover) return 1;
                                                        return a.orderRank - b.orderRank;
                                                    })
                                                    .map((slide, index) => (
                                                        <SwiperSlide className="crad_wrapper_img" key={index}>
                                                            {/* <img
                                                                ref={ref}
                                                                src={imgBaseUrl + slide?.path ?? NoPropertyImg}
                                                                alt={item.title}
                                                                className={isImgFlag ? "d-none" : "d-block"}
                                                                onError={({ currentTarget }) => {
                                                                    setIsImagFlag(true);
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                            /> */}
                                                            <img
                                                                src={slide?.path ? `${imgBaseUrl}${slide?.path}` : NoPropertyImg}
                                                                alt={item?.fileName || "property"}
                                                                loading="lazy"
                                                                decoding="async"
                                                                fetchPriority="low"
                                                                draggable={false}
                                                               onError={({ currentTarget }) => {
                                                                    setIsImagFlag(true);
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                            />

                                                            {isImgFlag ? <ImageLoader /> : ""}
                                                            {/* <ImageGallery
                                                                    src={slide?.path ? imgBaseUrl + slide?.path : NoPropertyImg}
                                                                    fallback={NoPropertyImg}
                                                                    // imageUrl={slide?.path ? imgBaseUrl + slide?.path : NoPropertyImg}
                                                                    onError={(e) => {
                                                                        setIsImagFlag(true);
                                                                        onError(e);
                                                                    }}
                                                                /> */}
                                                            {/* <UseCachedImage url={`${imgBaseUrl}${slide?.path}`} /> */}
                                                            {/* <ImageComponent src={imgBaseUrl + slide?.path} alt={`Slide ${index}`} className="swiper-lazy" style={{ width: "100%", height: "auto" }} /> */}
                                                        </SwiperSlide>
                                                    ))}
                                            <div className="swiper-button-prev" onClick={() => handlePrevClick()}></div>
                                            <div className="swiper-button-next" onClick={() => handleNextClick(item?.images)}></div>
                                            {item?.purposeType && (
                                                <div className="tag_label">
                                                    <p className="z_index-1">{item?.purposeType === "sale" ? `For ${item?.purposeType}` : `To ${item?.purposeType}`}</p>
                                                </div>
                                            )}
                                            {item?.completionType && (
                                                <div className="plan-label z_index-1">
                                                    <span>
                                                        {item?.completionType && (item?.completionType == "offplan" ? "Off-Plan" : "Ready")}
                                                        {item?.purposeSalesType && ` | ${item?.purposeSalesType}`}
                                                    </span>
                                                </div>
                                            )}
                                        </Swiper>
                                    ) : (
                                        <img src={NoPropertyImg} className="w-100 object-contain" style={{ height: "192px" }} alt="no property" loading="lazy" />
                                    )}
                                    <div className="card-actions z_index-1">
                                        <button
                                            className="btn-camera"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (!isImgFlag) {
                                                    if (item?.images.length > 0) {
                                                        setPropertyImgsmdl(item?.images);
                                                        setImgID(currentIndex);
                                                        setImgModalShow(true);
                                                    }
                                                }
                                            }}
                                        >
                                            <RECamera />
                                        </button>
                                        <button
                                            className="btn-favorite"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (isAuth) handleDisFavProperty(item);
                                                else handleLoginOpen();
                                            }}
                                        >
                                            <REMdHeart />
                                        </button>
                                    </div>
                                </div>

                                <div className="heading_title">
                                    <h3 className="card_ellipsis">{item?.title}</h3>
                                </div>
                                {item?.address?.locality && (
                                    <div className="geo-location">
                                        <RELocation />
                                        {/* <span className="card_ellipsis">{item?.address?.locality ?? ""}</span> */}
                                        <span className="card_ellipsis">
                                            <p>{[item?.address?.locality, item?.address?.city, item?.address?.state].filter(Boolean).join(", ")}</p>
                                        </span>
                                    </div>
                                )}
                                {(item?.monetary?.currency || item.category.name) && (
                                    <div className="property-price">
                                        {item?.monetary?.currency && (
                                            <p className="text-uppercase">
                                                {item?.monetary?.currency} {item?.monetary?.expectedPrice ? formatShortNumber(item?.monetary?.expectedPrice) : ""}
                                            </p>
                                        )}
                                        {/* <span>{item.category.name}</span> */}
                                    </div>
                                )}
                                <div className="property-data border border-0">
                                    <div className="property-details">
                                        {item.category.name && (
                                            <div className="detail-item">
                                                <div className="detail-count">
                                                    <p>{item.category.name}</p>
                                                </div>
                                            </div>
                                        )}
                                        {item?.noOfBhk && (
                                            <div className="detail-item">
                                                <div className="detail-count">
                                                    <REBedOutline />
                                                    <p>{item?.noOfBhk == 0 ? "Studio" : item?.noOfBhk}</p>
                                                </div>
                                            </div>
                                        )}
                                        {item?.frame?.bathRooms && (
                                            <div className="detail-item">
                                                <div className="detail-count">
                                                    <REBathtub />
                                                    <p>{item?.frame?.bathRooms}</p>
                                                </div>
                                            </div>
                                        )}
                                        {item?.frame?.washRooms && (
                                            <div className="detail-item">
                                                <div className="detail-count">
                                                    <REToilet />
                                                    <p>{item?.frame?.washRooms}</p>
                                                </div>
                                            </div>
                                        )}
                                        {item?.dimension?.propertyArea && (
                                            <div className="detail-item">
                                                <div className="detail-count">
                                                    <RESQFOOT />
                                                    <p>{formatNumber(item?.dimension?.propertyArea)}</p>
                                                    <p>{item.dimension.unit}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* {item?.rating && item?.rating > 0 && (
                                        <div className="property_data_inner">
                                            {(item?.rating == 1 || item?.rating == 2) && <p className="cold">Cold</p>}
                                            {item?.rating == 3 && <p className="warm">Warm</p>}
                                            {(item?.rating == 4 || item?.rating == 5) && <p className="hot">Hot</p>}
                                        </div>
                                    )} */}
                                </div>

                                <div className="property-data pb-2">
                                    {item?.agents && item?.agents?.isHighlyResponsive && (
                                        <div className="agent_intro">
                                            <div className="agent_avatar">
                                                <div className="agent_avatar_icon">
                                                    <img
                                                        src={imgBaseUrl + item?.agents?.path}
                                                        alt={item?.agents?.name}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = `${dummyPerson}`;
                                                        }}
                                                        loading="lazy"
                                                    />
                                                    {/* <div className="agent_icon_wrp">
                                                        <RiMedal2Fill color="#fff" />
                                                    </div> */}
                                                </div>
                                                <Link to={`/agent-details/${item?.agents?.uId}`}>
                                                    <p>{item?.agents?.name}</p>
                                                </Link>
                                            </div>
                                        </div>
                                    )}
                                    <div className="agent-actions action-control mt-0">
                                        {/* {item?.agents && (
                                        <div className="details-info pt-0">
                                            <div className="details-left">
                                                <img src={imgBaseUrl + item?.agents?.path} alt="" />
                                                <Link to={`/agent-details/${item?.agents?.uId}`}>
                                                    <p className="card_ellipsis">{item?.agents?.name}</p>
                                                </Link>
                                            </div>
                                        </div>
                                    )} */}
                                        <div className="">
                                            <button
                                                type="button"
                                                className="button primary_button"
                                                onClick={(e) => {
                                                    setEmailModalShow({ show: true, data: item });
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                }}
                                            >
                                                {/* <MdEmail /> */}
                                                Email
                                            </button>
                                        </div>
                                        {(item?.agents?.contactNumber || (agentData && Object.keys(agentData).length > 0)) && (
                                            <div className="">
                                                <button
                                                    type="button"
                                                    className="button primary_button"
                                                    onClick={(e) => {
                                                        setPhoneModalShow({ show: true, data: agentData ? agentData : item?.agents });
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                    }}
                                                >
                                                    {/* <IoMdCall /> */}
                                                    Call
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    {/* <div className="agent-actions-btn action-control-btn">
                                        <button>
                                            <TbBrandWhatsappFilled />
                                            Whatsapp
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        
                        {/* </article> */}
                    </div>
                ))}
            </div>

            {/* modal */}
            {imgModalShow && <ImagesModal show={imgModalShow} handleHide={handleClose} propertyImgsmdl={propertyImgsmdl} id={imgID} />}
            {emailModalShow && <EmailAgentModal show={emailModalShow.show} onHide={handleModalHide} pData={emailModalShow.data} type="property" />}
            {phoneModalShow.show && <ContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
            {loginModal && <Login show={loginModal} handleHide={handleLoginClose} onShow={handleLoginOpen} />}
        </>
    );
}
